import { Component, inject } from '@angular/core';
import { ToastService } from '../../../../core/services/toast.service';

@Component({
  selector: 'app-toast-container',
  standalone: true,
  template: `
    <div class="pointer-events-none fixed inset-x-0 bottom-4 z-[100001] flex flex-col items-center gap-2 px-4 sm:inset-x-auto sm:right-4 sm:items-end"
      aria-live="polite">
      @for (t of toastService.toasts(); track t.id) {
        <div role="status"
          class="pointer-events-auto flex w-full max-w-sm items-start gap-3 rounded-xl border px-4 py-3 text-sm shadow-lg"
          [class]="clases(t.tipo)">
          <span class="flex-1">{{ t.mensaje }}</span>
          <button type="button" (click)="toastService.cerrar(t.id)" aria-label="Cerrar"
            class="-my-1 -mr-2 flex h-8 w-8 flex-none items-center justify-center rounded-lg opacity-70 hover:opacity-100">
            <svg class="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"/>
            </svg>
          </button>
        </div>
      }
    </div>
  `,
})
export class ToastContainerComponent {
  readonly toastService = inject(ToastService);

  clases(tipo: string): string {
    switch (tipo) {
      case 'ok':
        return 'border-green-200 bg-green-50 text-green-800 dark:border-green-800 dark:bg-green-900/80 dark:text-green-100';
      case 'error':
        return 'border-red-200 bg-red-50 text-red-800 dark:border-red-800 dark:bg-red-900/80 dark:text-red-100';
      default:
        return 'border-gray-200 bg-white text-gray-800 dark:border-gray-700 dark:bg-gray-800 dark:text-gray-100';
    }
  }
}
